import { globalService } from './global.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
  } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Injectable } from "@angular/core";

  @Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
    constructor(
      private router: Router,
      private globServ: globalService
      ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler) {
      let clonedRequest;
      let token = this.globServ.shaToken;
      let userType;
      if(localStorage.getItem('loginType')){
        userType = localStorage.getItem('loginType')
      }else{
        userType = "";
      }
      clonedRequest = req;
      // console.log(req.url);

      if(token && token != '' && req.url != 'http://82.165.76.209:8057/administrative.svc/GetProjectTranslation?projectid=11' && req.url != 'http://sprache.bixbytessolutions.com/administrative.svc/GetProjectTranslation?projectid=11' &&
      !req.url.includes('storage/uploads')) {
        clonedRequest = req.clone({ headers: req.headers.set('Content-Type', 'application/json').set('Authorization', 'Bearer '+token).set('type', userType) });
      }

      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if(error.status == 401){
            console.log(error,'api error 401 trow');

            this.globServ.shaToken = '';
            localStorage.clear();
            this.router.navigate(['/guest/signin']);
          }
          return throwError(error);
        })
      );
    }
  }
